import Vue              from 'vue'
import Vuex             from 'vuex'
import * as types       from "./mutation-types"
import * as mainApi     from "./api/main"
import admin            from "./admin"
import catalog          from "./catalog"
import discounts        from "./discounts"
import pages            from "./pages"
import products         from "./products"
import orders           from "./orders"
import users            from "./users"
import images           from "./images"
import months           from "./months"
import referral_sources from "./referral_sources"
import reports          from "./reports"

Vue.use(Vuex)

let companies = {
  'CF': {
    'name': 'Crockett Farms',
    'short_name': 'Crockett',
    'initials': 'CF',
  },
  'BELLS': {
    'name': 'Bells Farm to Market',
    'short_name': 'Bells',
    'initials': 'BELLS',
  },
  'FVG': {
    'name': 'Ferris Valley Groves',
    'short_name': 'Ferris',
    'initials': 'FVG',
  },
  'KY': {
    'name': 'K-Y Farms',
    'short_name': 'K-Y',
    'initials': 'KY',
  },
  'RGR': {
    'name': "Roger's Farms",
    'short_name': 'Roger\'s',
    'initials': 'RGR',
  },
  'STF': {
    'name': 'Sugar Tree Farms',
    'short_name': 'Sugar Tree',
    'initials': 'STF',
  },
  'ZEY': {
    'name': 'Zeys of Texas',
    'short_name': 'Zeys',
    'initials': 'ZEY',
  }
}

const store = new Vuex.Store({
  strict: false,
  modules: {
    admin,
    catalog,
    discounts,
    pages,
    products,
    orders,
    users,
    images,
    months,
    referral_sources,
    reports
  },

  state: {
    company: {
      'name': 'Crockett Farms',
      'short_name': 'Crockett',
      'initials': 'CF',
    },
    load_complete: false,
    API_BUSY: false,
    API_ERROR: false,
    subscriptions: [],
  },

  getters: {
    apiBusy: (state) => state.API_BUSY === true,
    apiError: (state) => state.API_ERROR !== false ? state.API_ERROR : false,
    subscriptions: (state, getters) => state.subscriptions
                                            .filter(subscription => getters.company.initials === null ||
                                                                    subscription.company === getters.company.initials),
    company: (state) => state.company,
    companies: (state) => companies,
    loadComplete: (state) => state.load_complete,
  },

  mutations: {
    [types.SET_API_BUSY](state, payload) {
      state.API_BUSY = payload
    },
    [types.SET_API_ERROR](state, payload) {
      state.API_ERROR = payload
    },
    [types.FETCH_PRIORITY_DATA](state, payload) {
      state.company                     = payload.company
      state.admin.all                   = payload.admins
      state.orders.all                  = payload.orders
      state.orders.last_sync            = Date.now()
      state.products.all                = payload.products
      state.discounts.all               = payload.discounts
      state.catalog.all                 = payload.catalog_requests
      state.subscriptions               = payload.subscriptions
      state.months.all                  = payload.months
      state.images.all                  = payload.images
      state.images.imageables           = payload.imageables
      state.pages.all                   = payload.pages
      state.pages.contents              = payload.page_contents
      state.products.bundles            = payload.bundles
      state.products.categories         = payload.categories
      state.products.items              = payload.items
      state.products.tags               = payload.tags
      state.products.product_bundles    = payload.product_bundles
      state.products.product_categories = payload.product_categories
      state.products.product_items      = payload.product_items
      state.products.product_parts      = payload.product_parts
      state.products.product_tags       = payload.product_tags
      state.referral_sources.all        = payload.referral_sources
    },
    [types.FETCH_DATA](state, payload) {
      state.orders.past_orders = payload.past_orders
      state.load_complete      = true;
    },
    [types.SET_COMPANY](state, company) {
      if (company === null) {
        state.company = {
          name: 'All Companies',
          short_name: 'Fruit',
          initials: null,
        }
      }
      else {
        state.company = companies[company]
      }
    }
  },

  actions: {
    [types.FETCH_DATA]: ({ commit, dispatch, state }) => {
      return new Promise((resolve, reject) => {
        mainApi.fetchData(commit)
               .then(data => {
                 commit(types.FETCH_DATA, data)
                 resolve(data)
               })
               .catch(error => {
                 reject(error)
               });
      })
    },
    [types.FETCH_PRIORITY_DATA]: ({ commit, dispatch, state }) => {
      return new Promise((resolve, reject) => {
        mainApi.fetchPriorityData(commit)
               .then(data => {
                 commit(types.FETCH_PRIORITY_DATA, data)
                 resolve(data)
               })
               .catch(error => {
                 reject(error)
               });
      })
    },
    [types.SET_COMPANY]: ({ commit, dispatch, state }, company) => {
      return new Promise((resolve, reject) => {
        commit(types.SET_COMPANY, company)
        commit(types.SET_REPORT_COMPANY, company)
      })
    }
  }
})

export default store



//////////////////
// WEBPACK FOOTER
// ./vue/src/store/index.js
// module id = 41
// module chunks = 0